import React from 'react'

import { Header, Title } from './CommunityListingHeader.styles'

interface CommunityListingHeaderProps {
  title: string
}

const CommunityListingHeader = (props: CommunityListingHeaderProps) => (
  <Header>
    <Title as="h1">{props.title}</Title>
  </Header>
)

export default CommunityListingHeader
